<template>
  <v-container class="container-max-width">
    <v-row v-if="isLoading" id="syncio-loading-logo">
      <v-col class="text-center">
        <loading-syncio-logo></loading-syncio-logo>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col>
        <v-row>
          <v-col cols="12" class="align-center">
            <div class="text-center relative">
              <v-icon size="40" @click="$router.go(-1)" class="absolute go-back-link">
                chevron_left
              </v-icon> 
              <svg width="120px" height="30px" viewBox="0 0 100 30" style="transform: translateX(-6px);">
                <circle cx="10" cy="10" r="9" class="filled"/>
                <line x1="19" y1="10" x2="31" y2="10" class="line"/>
                <circle cx="40" cy="10" r="9" class="filled"/>
                <line x1="61" y1="10" x2="49" y2="10" class="line"/>
                <circle cx="70" cy="10" r="9" class="not-filled"/>
                <line x1="91" y1="10" x2="79" y2="10" class="line"/>
                <circle cx="100" cy="10" r="9" class="not-filled"/>
              </svg>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="text-center">
            <p class="text-h8 mb-2 font-weight-bold font-primary">STEP 2</p>
            <div class="text-h1 primary--text">
              Connect to your first source store!
            </div>
          </v-col>
        </v-row>
        <v-row class="mt-4">
          <v-col>
            <v-card class="px-8 pt-10 pb-7 card-rounded not-a-link">
              <v-row>
                <v-col>
                  <div class="text-subtitle-2">
                    Connect to a source store using a unique key.
                  </div>
                  <div class="text-body-2 mt-6">
                    Once connected, you will be able to start importing products from this source store.
                  </div>
                </v-col>
              </v-row>
              <v-row class="mt-6">
                <v-col cols="12" class="pb-0">
                  <div class="text-caption caption-color">
                    Source store unique key
                  </div>
                </v-col>
                <v-col cols="9" class="mt-1 pt-1">
                  <v-text-field
                    filled
                    v-model="uniqueKey"
                    @change="$v.uniqueKey.$touch()"
                    :error-messages="checkUniqueKeyErrors"
                    dense
                  >
                  </v-text-field>
                </v-col>
                <v-col class="pt-1">
                  <v-btn class="primary rounded-lg" width="100%" height="48px" @click="connectStoreWithKey">
                    <div class="text-body-1">
                      Connect
                    </div>
                    <div class="ml-1">
                      <v-icon size="20" right>
                        add
                      </v-icon>
                    </div>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
        <v-row class="text-center mt-7" v-if="isConnect === false">
          <v-col>
            <div class="text-body-2">
              <router-link class="text-decoration-none" to="/shopify/select-plan">Skip for now.</router-link>
            </div>
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col class="text-center">
            <v-btn class="primary rounded-lg" width="150px" height="48px" @click="$router.push('/shopify/select-plan')">
              <div class="text-body-1">
                Next
              </div>
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {required} from "vuelidate/lib/validators";
import {mapGetters} from "vuex";
import LoadingSyncioLogo from "@/views/registration/components/LoadingSyncioLogo";

export default {
  name: "ConnectStore",
  components: {LoadingSyncioLogo},
  data() {
    return {
      uniqueKey:"",
      isConnect: false
    }
  },
  validations: {
    uniqueKey: { required },
  },
  computed: {
    ...mapGetters("shop", ["currentShop", "isLoading"]),
    checkUniqueKeyErrors () {
      const keyErrors = [];
      if (!this.$v.uniqueKey.$dirty) return keyErrors
      !this.$v.uniqueKey.required && keyErrors.push('Key is required')
      return keyErrors
    },
  },
  created() {
    this.$store.dispatch(`shop/loadCurrentShop`)
  },
  methods: {
    connectStoreWithKey(){
      this.$v.$touch();
      if (!this.$v.$invalid){
        this.$store.dispatch(`shop/connectStoreWithKey`, {shopId: this.currentShop.id, key: this.uniqueKey}).then(() => {
          this.isConnect = true;
        });
      }
    }
  }
}
</script>

<style scoped>
.container-max-width {
  max-width: 700px !important;
}

.caption-color{
  color: #525252;
}

#syncio-loading-logo {
  left: 50%;
  position: fixed;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
}
</style>
